package org.hs_soft.runmynesto.pages.home.sub_page.template.component.tabs.tab_general.component

import androidx.compose.runtime.Composable
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.foundation.layout.Spacer
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.borderBottom
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.cursor
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxHeight
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.fontFamily
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.minHeight
import com.varabyte.kobweb.compose.ui.modifiers.onClick
import com.varabyte.kobweb.compose.ui.modifiers.onMouseLeave
import com.varabyte.kobweb.compose.ui.modifiers.onMouseOver
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.silk.components.text.SpanText
import org.hs_soft.runmynesto.domain.config.Dimen
import org.hs_soft.runmynesto.domain.config.FontFamily
import org.hs_soft.runmynesto.domain.config.FontSizes

import org.hs_soft.runmynesto.domain.config.Theme
import org.hs_soft.runmynesto.domain.config.backgroundDialog
import org.hs_soft.runmynesto.domain.config.generalDialogSetting
import org.hs_soft.runmynesto.domain.config.rippleEffect
import org.hs_soft.runmynesto.domain.model.home.product.products_list_model.ProductItem
import org.hs_soft.runmynesto.domain.util.helper.Strings
import org.hs_soft.runmynesto.pages.components.HeaderTitle
import org.hs_soft.runmynesto.pages.components.InfiniteScrollGrid
import org.hs_soft.runmynesto.pages.components.grid_function.GridFooter
import org.jetbrains.compose.web.css.LineStyle

@Composable
fun AddProductToArticleDialog(
    searchedProductItems: List<ProductItem>,
    onBackgroundClick: () -> Unit,
    onItemClick:(String)->Unit,
)
{
    Box(
        modifier = Modifier
            .backgroundDialog()
            .onClick {
                onBackgroundClick()
            }
    ){
        Column(
            modifier = Modifier
                .align(Alignment.Center)
                .width(Dimen.verticalDialogWidth)
                .height(Dimen.verticalAIDialogHeight)
                .generalDialogSetting()
            ,
            horizontalAlignment = Alignment.CenterHorizontally
        ){


            Row(
                modifier = Modifier
                    .fillMaxWidth()
                    .height(Dimen.gridHeaderHeight)
                    .borderBottom(
                        width = Dimen.smallThickness,
                        style = LineStyle.Solid,
                        color = Theme.ActionDisabledBackground.rgb
                    )
                    .backgroundColor(Theme.ActionHover.rgb)
                    .padding(
                        leftRight = Dimen.mediumPadding,
                        topBottom = Dimen.normalPadding
                    ),
                verticalAlignment = Alignment.CenterVertically
            ){
                HeaderTitle(
                    title =  Strings.current().creatingNewProduct,
                    fillMaxWidth = true
                )
            }


            InfiniteScrollGrid(
                modifier = Modifier
                    .fillMaxHeight()
                    .fillMaxWidth()
                    .weight(1f)
                ,
                items = searchedProductItems,
                onLoadMore = {}
            ){
                val model=searchedProductItems[it]
                productItem(
                    model=model,
                    onItemClick={
                        onItemClick(model.id)
                    },
                )
            }



            Spacer()


            GridFooter(
                title = Strings.current().products,
                dataSize = searchedProductItems.size,
                width = null,
                showRefreshIcon = false,
            )



        }
    }



}

@Composable
private fun productItem(
    onItemClick: (String) -> Unit,
    model: ProductItem
) {
    val isHovered = remember { mutableStateOf(false) }

    Column(
        modifier = Modifier
            .fillMaxWidth()
            .minHeight(Dimen.gridItemHeight)
            .cursor(Cursor.Pointer)
            .borderBottom(
                width = Dimen.smallThickness,
                color = Theme.ActionDisabledBackground.rgb,
                style = LineStyle.Solid,
            )
            .rippleEffect {
                onItemClick(model.id)

            }
            .onMouseLeave {
                isHovered.value = false
            }
            .onMouseOver {
                isHovered.value = true
            }
            .backgroundColor(
                when {
//                    isSelected.value -> Theme.GrayAlpha12.rgb
                    isHovered.value -> Theme.ActionHover.rgb
                    else -> Theme.Transparent.rgb
                }
            )
            ,
            verticalArrangement = Arrangement.Center
    ) {
        Box(
            modifier = Modifier
                .fillMaxWidth()
                .height(Dimen.gridItemHeight)

        )
        {
            SpanText(
                text = model.name ?: "",
                modifier = Modifier
                    .margin(left = Dimen.mediumPadding)
                    .align(Alignment.CenterStart)
                    .color(Theme.TextPrimary.rgb)
                    .fontFamily(FontFamily.Jakarta)
                    .fontSize(FontSizes.mediumFontSize)

            )


        }

    }
}